import { render, staticRenderFns } from "./IcoPlayTriangle.vue?vue&type=template&id=f496fb7c"
import script from "./IcoPlayTriangle.vue?vue&type=script&lang=js"
export * from "./IcoPlayTriangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports